import { useState } from 'react';
import EditorLink from 'lowcode/components/EditorLink';
import styled from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import { NA_SITES } from '@/constants/membersday';
import { useMembersDispatch, useMembersStore } from '../../../MembersProvider';
import { getPrivacyPolicy } from '@/utils/common';

const CheckIcon = ({ ...props }) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <rect x="0.5" y="0.5" width="13" height="13" stroke="#FFBD3C" />
        <path d="M3 6.5L5.5 9L10.5 4" stroke="#FFBD3C" strokeWidth="1.2" strokeLinecap="square" />
    </svg>
);

export default function JPEmailBox() {
    const { t } = useLang('membersday.activity');
    const { locale } = getLocal();
    const [isActive, setIsActive] = useState(true);
    const dispatch = useMembersDispatch();
    const { secKillisBegin } = useMembersStore();

    const href = secKillisBegin ? 'activity-FlashSale' : 'activity-BestSellers';

    const handleOpenJoinUs = () => {
        if (!isActive) return;
        dispatch({
            type: 'changeJoinUsWinStatus',
            payload: true,
        });
    };

    const handleScrollTo = () => {
        document.getElementById(href)?.scrollIntoView({
            behavior: 'smooth',
        });
    };

    return (
        <div className={styled.JoinUsLead}>
            <EditorLink className="lead_btn" onClick={handleScrollTo}>
                {t('product_price_buy_now')}
            </EditorLink>
            {/* <EditorLink className="lead_btn" onClick={handleOpenJoinUs}>
                {t('product_price_buy_now')}
            </EditorLink> */}
            {/* <div className={`lead_protocol ${isActive ? 'lead_active' : ''}`} onClick={() => setIsActive(!isActive)}>
                <span className="lead_icon">
                    <CheckIcon />
                </span>
                {t.rich('joinInProtocol', {
                    link: (text: string) => {
                        return (
                            <a className="link" href={getPrivacyPolicy(locale)} target="_blank" rel="noreferrer">
                                {text}
                            </a>
                        );
                    },
                    link2: (text: string) => (
                        <a className="link" href={`https://${locale}.ecoflow.com/policies/terms-of-service`} target="_blank" rel="noreferrer">
                            {text}
                        </a>
                    ),
                })}
            </div> */}
        </div>
    );
}
